import React, { useContext, useEffect, useState } from 'react';
import './SocialHiveSettings.css';
import { FiSettings, FiTrash2, FiEdit2, FiChevronDown } from 'react-icons/fi';
import SHInput from '../../components/SHInput/SHInput';
import { useLanguage } from '../../../../LanguageProvider';
import AlertBox from '../../../../components/AlertBox/AlertBox';
import { GeneralContext } from '../../../../GeneralProvider';
import SocailHiveSettingsAuthorization from './views/SocailHiveSettingsAuthorization';
import SocialHiveSettingsUpdate from './views/SocialHiveSettingsUpdate';
import SocialHiveInviteChannel from './views/SocialHiveInviteChannel';
import Services from '../../../../services/Services';
import SocialHiveRoomGroupSettings from './views/SocialHiveRoomGroupSettings.js';

const SocialHiveSettings = ({ selectedChannel, handleChannelChange, activeMenu, setActiveMenu }) => {
    const { handleDeleteChannel, handleLeaveChannel, myChannels, userId, getMyChannels } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isAdmin, setIsAdmin] = useState("0");
    const [isOwner, setIsOwner] = useState(false);

    const sidebarMenu = [
        { key: 'authorizations', label: getTranslation("authorizations") },
        { key: 'channelSettings', label: getTranslation("channelSettings") },
        { key: 'roomGroups', label: getTranslation("rooms") }
        // { key: 'invite', label: getTranslation("invite") }
    ];

    const handleConfirmDelete = () => {
        handleDeleteChannel(selectedChannel.channelID);
        setIsAlertOpen(false);
        handleChannelChange();
    }

    useEffect(() => {
        if (myChannels.find(x => x.channelID === selectedChannel.channelID).ownerID === userId) {
            setIsOwner(true)
        }
        setIsAdmin(myChannels.find(x => x.channelID === selectedChannel.channelID).isAdmin)
    }, []);
    return (
        <div className="sh-settings-container">
            {/* <aside className="sh-settings-sidebar">
                <div className="sh-settings-sidebar-header">
                    <span>{getTranslation("settings")}</span>
                    <FiSettings />
                </div>


                {isAdmin === "1" &&
                    <nav className="sh-settings-sidebar-menu">
                        {sidebarMenu.map(item => (
                            <div
                                key={item.key}
                                className={`sh-settings-sidebar-item ${activeMenu === item.key ? 'active' : ''}`}
                                onClick={() => setActiveMenu(item.key)}
                            >
                                {item.label}
                            </div>
                        ))}
                    </nav>
                }


                {isOwner ?
                    <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', marginBottom: '15px' }}>
                        <div onClick={() => setIsAlertOpen(true)} style={{ marginTop: 'auto', alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="collaborators-table-reject-button">
                            {getTranslation("deleteChannel")}
                        </div>
                    </div>
                    :
                    <div style={{ width: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex', marginBottom: '15px', marginTop: 'auto' }}>
                        <div onClick={() => { handleLeaveChannel(selectedChannel.channelID); handleChannelChange(); }} style={{ marginTop: 'auto', alignItems: 'center', justifyContent: 'center', display: 'flex', width: '80%', borderRadius: '4px' }} className="collaborators-table-reject-button">
                            {getTranslation("leaveChannel")}
                        </div>
                    </div>
                }

            </aside> */}

            {isAdmin === "1" ?
                <>
                    {activeMenu === "authorizations" && <SocailHiveSettingsAuthorization selectedChannel={selectedChannel} />}
                    {activeMenu === "channelSettings" && <SocialHiveSettingsUpdate selectedChannel={selectedChannel} />}
                    {activeMenu === "invite" && <SocialHiveInviteChannel selectedChannel={selectedChannel} />}
                    {activeMenu === "roomGroups" && (
                        <SocialHiveRoomGroupSettings
                            selectedChannel={selectedChannel}
                            updateSettings={(updatedGroups) => {
                                const token = localStorage.getItem("token");
                                Services.SocialHiveUpdateChannelSettings(token, selectedChannel.channelID, updatedGroups).then(() => {
                                    getMyChannels()
                                });
                            }}
                        />
                    )}
                </> :
                <>
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                        {selectedChannel.logo ?
                            <img
                                src={selectedChannel.logo}
                                alt={selectedChannel.title}
                                width={200}
                                height={200}
                                style={{ borderRadius: '50%' }}
                            />
                            :
                            <div style={{ width: '200px', height: '200px', backgroundColor: '#ccc', borderRadius: '50%' }} />
                        }

                        <span className='sh-discover-title'>
                            {selectedChannel?.title}
                        </span>

                        <span className='sh-discover-description'>
                            {selectedChannel?.description}
                        </span>

                    </div>
                </>
            }



            <AlertBox
                isOpen={isAlertOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("deleteChannelConfirmation")}
                onConfirm={handleConfirmDelete}
                onCancel={() => setIsAlertOpen(false)}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />
        </div>
    );
};

export default SocialHiveSettings;
